module.exports = __webpack_public_path__ + "static/img/overseas-3.47d04b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/overseas-3.png
// module id = cXf6
// module chunks = 1